'use strict';

export default {
    STORE_LANGUAGE_KEY: 'mediabox_user_language'
};


// WEBPACK FOOTER //
// ./app/utils/mb_consts.js